<template>
  <component
    class="text-base font-medium px-2.5 py-2 dark:text-dark-50 rounded-md cursor-pointer flex items-center sm:h-10"
    :is="component"
    :to="item.to"
    :class="[
      isActive ? styles[1] : styles[0],
      item.isSelected ? 'pointer-events-none' : '',
      item.isGreyed ? 'opacity-50 pointer-events-none' : ''
    ]"
    @click="() => item.children && item.children.length > 0 ? emit('open') : action()"
  >
    <span class="grow line-clamp-1 break-all">{{ item.label }}</span>

    <IconBase name="cute/angle-right" :width="20" v-if="item.children" />
    
    <template v-if="!isLoading">
      <InputCheckbox :id="item.id" class="pointer-events-none ml-1" :model-value="item.isChecked" v-if="item.isChecked !== undefined" />
      <InputRadio class="pointer-events-none ml-1" :model-value="item.isSelected ? item.id : ''" :name="parent?.id ?? item.id" :value="item.id" :is-disabled="item.isGreyed" v-if="item.isSelected !== undefined" />
    </template>

    <IconBase name="cute/spinner" class="spin ml-1" :width="18" v-if="isLoading"  />
  </component>
</template>

<script lang="ts" setup>
import { ContextItem2 } from '@/utils/useContext'

const props = withDefaults(defineProps<{
  item: ContextItem2
  parent?: ContextItem2
  isActive?: boolean
}>(), {

})

const isLoading = ref(false)

const action = async () => {
  isLoading.value = true
  
  if (props.item.action) await props.item.action()
  if (props.item.emit) emit(props.item.emit)

  emit('close')

  isLoading.value = false
}

const styles = computed(() => {
  if (props.item.type === 'important') {
    return ['bg-ruby-100 text-ruby-500 dark:bg-ruby-600/30', 'bg-ruby-500 text-white']
  } else {
    return ['hover:bg-royal-200/50 text-light-950 hover:bg-dark-900/30', 'bg-charcoal-950 text-white']
  }
})

const component = computed(() => {
  if (props.item.to) return resolveComponent('NuxtLink')

  return 'div'
})

const emit = defineEmits([ 'close', 'open', 'react-list', 'answer', 'retry' ])
</script>